// removed by extract-text-webpack-plugin
module.exports = {"wysiwyg":"Wysiwyg-m__wysiwyg___2-Tsp"};


//////////////////
// WEBPACK FOOTER
// ./components/wysiwyg/Wysiwyg.m.sass
// module id = 6x4O
// module chunks = 0